export const NEW_GLOBAL_TOOLBAR_HEIGHT = '44px';